module.exports = __webpack_public_path__ + "static/img/ptGame4.0440046.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/ptGame4.png
// module id = g8nb
// module chunks = 3